(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.Repatch = {})));
}(this, (function (exports) { 'use strict';

var thunkFactory = function (extraArgument) {
    var thunk = (function (store) { return function (next) { return function (reducer) {
        if (typeof reducer !== 'function')
            throw new Error('Thunk reducer must return a function');
        var result = reducer(store.getState());
        if (typeof result === 'function')
            return result(store.dispatch, store.getState, extraArgument);
        else
            return next(function (_) { return result; });
    }; }; });
    thunk.withExtraArgument = thunkFactory;
    return thunk;
};
var thunk = thunkFactory();

var Store = (function () {
    function Store(initialState) {
        var _this = this;
        this.listeners = [];
        this.isDispatching = false;
        this.getState = function () { return _this.state; };
        this.dispatch = function (reducer) {
            if (typeof reducer !== 'function')
                throw new Error('Reducer is not a function: dispatch takes only reducers as functions.');
            if (_this.isDispatching)
                throw new Error('Reducers may not dispatch actions.');
            _this.isDispatching = true;
            try {
                _this.state = reducer(_this.state);
            }
            finally {
                _this.isDispatching = false;
            }
            for (var i = 0; i < _this.listeners.length; ++i)
                _this.listeners[i]();
            return _this.state;
        };
        this.subscribe = function (listener) {
            if (typeof listener !== 'function')
                throw new Error('Listener is not a function: subscribe takes only listeners as functions.');
            _this.listeners = _this.listeners.concat([listener]);
            return function () { return (_this.listeners = _this.listeners.filter(function (lis) { return lis !== listener; })); };
        };
        this.addMiddleware = function () {
            var middlewares = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                middlewares[_i] = arguments[_i];
            }
            if (middlewares.some(function (middleware) { return typeof middleware !== 'function'; }))
                throw new Error('Middleware is not a function: addMiddleware takes only middlewares as functions.');
            middlewares.forEach(function (middleware) { return (_this.dispatch = middleware(_this)(_this.dispatch)); });
            return _this;
        };
        this.state = initialState;
    }
    return Store;
}());

exports.Store = Store;
exports['default'] = Store;
exports.thunk = thunk;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=repatch.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/repatch/dist/repatch.js
// module id = 646
// module chunks = 0